import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { showNotification as showNotificationAction, refreshView as refreshViewAction } from 'react-admin';
import fetchApi from "../../fetchApi";
import PopupDialog from "../../components/PopupDialog";
import UnitsInput from "../../fields/UnitsInput";
import { Form } from 'react-final-form'

class ScheduleSettlementButton extends Component {
    constructor(props) {
        super(props);

        this.state = {submitting: false, open: false}
    }
    handleConfirm = () => {
        const { record, showNotification, refreshView } = this.props;

        this.setState({submitting: true})
        fetchApi(record._links.scheduleSettlement.href, {
            method: 'POST',
        }).then(() => {
            showNotification('Settlement scheduled', 'info');

            refreshView();
            this.setState({submitting: false})
        }).catch((e) => {
            showNotification('Error scheduling settlement', 'error');
            this.setState({submitting: false})
        });
    };

    handleClose = () => {
        this.setState({open: false})
    }

    handleOpen = () => {
        this.setState({open: true})
    }

    render() {
        const {submitting, open} = this.state;

        return <div>
              <PopupDialog open={open} onOk={this.handleConfirm} onClose={this.handleClose} title={"Schedule settlement?"}/>
            {this.props.record._links && this.props.record._links.scheduleSettlement &&
                <Button variant={'contained'} color={'primary'} disabled={submitting} onClick={this.handleOpen}>Schedule settlement</Button>
            }
            <span style={{visibility: !submitting ? 'hidden' : 'visible'}}><CircularProgress/></span>
            </div>;
    }
}

ScheduleSettlementButton.propTypes = {
    record: PropTypes.object,
    showNotification: PropTypes.func,
    refreshView: PropTypes.func,
};

export default connect(null, {
    showNotification: showNotificationAction,
    refreshView: refreshViewAction,
})(ScheduleSettlementButton)